import React from "react";
import Lucide from "./Lucide";
import Button from "react-bootstrap/Button";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import Dropdown from "react-bootstrap/Dropdown";

import { innerComponent } from "@global/actions";
var composite, item_select, moduleName;
export default function IToolbar(props) {
  return (
    <div className="iws-toolbar">
      {props.navItems.map((item, index) => (
        <div
          className="buttons d-flex flex-row"
          key={item.id}
          id={"tool-" + item.id}
        >
          <IElment item={item} props={props} />
        </div>
      ))}
    </div>
  );
}

function IElment({ item, props }) {
  switch (item.element) {
    case "ipopover":
      var component = props.composite[item.id];
      return (
        <>
          <div className="left-button" title={item?.title}>
            <Lucide
              icon={item.icon}
              className="lucide-toolbar"
              color={item?.color}
            />
          </div>

          <OverlayTrigger
            className="popover-width"
            trigger="click"
            placement="bottom"
            overlay={
              <Popover>
                <Popover.Header as="h3">
                  {item.title}
                  <span className="float-right">
                    <Button
                      type="button"
                      onClick={() => document.getElementById(item.id).click()}
                      className="btn-close"
                      aria-label="Close"
                    ></Button>
                  </span>
                </Popover.Header>
                <Popover.Body>{component}</Popover.Body>
              </Popover>
            }
          >
            <Button className="right-button" id={item.id}>
              {item.title}
            </Button>
          </OverlayTrigger>
        </>
      );

    case "component":
      return (
        <>
          <div className="left-button" title={item?.title}>
            <Lucide
              icon={item.icon}
              className="lucide-toolbar"
              color={item?.color}
            />
          </div>
          {props.composite[item.id]}
        </>
      );

    case "dropdown":
      return (
        <Dropdown>
          <Dropdown.Toggle
            className="left-button"
            bsPrefix="bsPrefix"
          ></Dropdown.Toggle>
          <Dropdown.Menu>
            {item.list.map((subitem, index) => (
              <Dropdown.Item href="#" onClick={() => init(props, subitem)}>
                {" "}
                {subitem.title}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      );

    default:
      return (
        <>
          <div className="left-button" title={item?.title}>
            <Lucide
              icon={item.icon}
              className="lucide-toolbar"
              color={item?.color}
            />
          </div>
          <button className="right-button" onClick={() => init(props, item)}>
            {item.title}
          </button>
        </>
      );
  }
}

//

const init = (props, item) => {
  moduleName = props.moduleName;
  composite = props.composite;
  item_select = item;
  var component = composite[item_select.id];
  switch (item_select.action) {
    case "modal":
      break;
    case "method":
      var containerId = document.getElementById("eval-container-function");
      containerId.appendChild(
        innerComponent(component, "eval-container-function-child")
      );
      break;
    case "innerHtml":
      var containerId = document.getElementById(item_select.containerId);
      containerId.appendChild(
        innerComponent(component, item_select.containerId + "child")
      );
      break;

    default:
      break;
  }
};
